<template>
  <Dropdown class="white-bg"
    v-if="hasUser"
    :titleDropdown="getAccount.name"
    :sameSize="true"
    class-title="truncate-1 pl-2"
    color-arrow="black"
  >
    <ul class="mb-1 truncate-1">
      <router-link
        tag="li" :to="`/definitions?tab=users&userId=${getUser.id}`"
        :title="getUser.email"
        class="dropdown-item text-center"
      >
        {{ getUser.name}}
      </router-link>

      <router-link
        tag="li"
        to="/accounts"
        title="Mudar de conta"
        class="dropdown-item text-center"
      >
        Contas

      </router-link>
      <li class="dropdown-item text-center" v-if="!isPretender" @click="logout">Sair</li>
    </ul>
  </Dropdown>
</template>

<script>
  import GetUser from '@/mixins/GetUser'
  import GetAccount from '@/mixins/GetAccount'
  import Dropdown from './specialTag/Dropdown'

  export default {
    components: { Dropdown },
    computed: {
      isPretender() {
        return this.getUser.pretender
      }
    },
    methods: {
      handleVisibilityChange() {
        const lastAccountId = this.$ls.get('last_account_id', { withoutKey: true })
        if (!document.hidden && lastAccountId !== this.getAccount.id) {
          this.$ls.remove('last_account_id', { withoutKey: true })
          location.href = '/'
        }
      },
      logout() {
        this.axios.delete('/auth/sign_out')
          .then(() => this.$ls.clearAccountUser())
          .then(() => localStorage.removeItem('authHeaders'))
          .finally(() => {
            this.setUser(null)
            this.$router.push('/login')
          })
      }
    },
    mixins: [GetAccount, GetUser],
    name: 'User',
    mounted() {
      const lastAccountId = this.$ls.get('last_account_id', { withoutKey: true })
      if (!lastAccountId && this.getAccount?.id) 
        this.$ls.set('last_account_id', this.getAccount.id, { withoutKey: true, minutes: 60 * 24 })
      
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    },
    beforeDestroy() {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    },
  }

</script>

<style lang="scss" scoped>
  .bkps-dropdown{
    border: solid 1px var(--dropdown-border-color);
    color: var(--dropdown-text-color);
    width: 175px;
  }

  li {
    cursor: pointer
  }
</style>
